"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaChamp = void 0;

var _react = _interopRequireWildcard(require("react"));

var _MfaEnveloppe = require("./MfaEnveloppe");

var _utilitaires = require("../utils/utilitaires");

require("../css/mfa-texte.css");

var _MfaChampProprietes = require("../commun/MfaChampProprietes");

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaChamp = /*#__PURE__*/function (_Component) {
  _inherits(MfaChamp, _Component);

  var _super = _createSuper(MfaChamp);

  function MfaChamp(props) {
    var _this;

    _classCallCheck(this, MfaChamp);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "idChamp", void 0);

    _defineProperty(_assertThisInitialized(_this), "tailles", ['sm', 'md', 'lg', 'xl', 'xxl']);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _this.changement = _this.changement.bind(_assertThisInitialized(_this));
    _this.changementInterne = _this.changementInterne.bind(_assertThisInitialized(_this));
    _this.validationInterne = _this.validationInterne.bind(_assertThisInitialized(_this));
    _this.validation = _this.validation.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.state = {
      messageErreur: null
    };
    _this.idChamp = (0, _utilitaires.estDefini)(_this.props.id) ? _this.props.id : (0, _utilitaires.guid)();
    return _this;
  }

  _createClass(MfaChamp, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          estVisible = _this$props.estVisible,
          classeEnveloppe = _this$props.classeEnveloppe;

      if (estVisible === false) {
        return null;
      }

      var props = this.obtenirPropsFiltrees();
      var valeur = this.valeurCourante();

      if ((0, _utilitaires.estDefini)(valeur)) {
        props.value = valeur;
      }

      return /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
        ref: function ref(_ref) {
          return (0, _utilitaires.estDefini)(_ref, 'element') ? _this2.enveloppe = _ref.element : null;
        },
        className: (0, _utilitaires.estDefini)(classeEnveloppe) ? classeEnveloppe : null,
        nePasAjuster: this.props.nePasAjuster,
        estObligatoire: this.props.estObligatoire,
        etiquette: this.props.etiquette,
        infoBulle: this.props.infoBulle,
        idChamp: this.idChamp,
        messageErreur: this.obtenirMessageErreur(),
        precision: this.props.precision,
        etiquetteEmplacement: this.props.etiquetteEmplacement,
        taille: this.obtenirTaille(),
        sansRembourrage: this.props.sansRembourrage
      }, this.props.lectureSeule === true ? this.obtenirValeurForcee() : this.obtenirControle(), (0, _utilitaires.estDefini)(this.props.children) ? this.props.children : null);
    }
  }, {
    key: "obtenirValeurForcee",
    value: function obtenirValeurForcee() {
      var props = this.obtenirPropsFiltrees();
      var _this$props2 = this.props,
          valeur = _this$props2.valeur,
          valeurInitiale = _this$props2.valeurInitiale;

      if (!(0, _utilitaires.estDefini)(valeur)) {
        valeur = valeurInitiale;
      }

      if (!(0, _utilitaires.estDefini)(valeur)) {
        return this.obtenirControleChaine(null, props);
      }

      if (valeur instanceof Array && valeur.every(function (val) {
        return typeof val === 'string';
      })) {
        return /*#__PURE__*/_react.default.createElement("ul", _extends({
          className: "mfa-valeur-multiple"
        }, props), valeur.map(function (val, index) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: index
          }, val);
        }));
      }

      return this.obtenirControleChaine((0, _utilitaires.nestPasNulOuVide)(valeur) ? valeur : "\xa0", props);
    }
  }, {
    key: "obtenirClasseChaine",
    value: function obtenirClasseChaine() {
      var classe = "mfa-lectureseule";
      var sansRembourrage = this.props.sansRembourrage;

      if (sansRembourrage === true) {
        classe += " sans-rembourrage";
      }

      return classe;
    }
  }, {
    key: "obtenirControleChaine",
    value: function obtenirControleChaine(chaine, props) {
      return /*#__PURE__*/_react.default.createElement("span", _extends({
        className: this.obtenirClasseChaine()
      }, props), (0, _utilitaires.nestPasNulOuVide)(chaine) ? chaine : "\xa0");
    }
  }, {
    key: "obtenirTaille",
    value: function obtenirTaille() {
      var _this$props3 = this.props,
          taille = _this$props3.taille,
          tailleMinimale = _this$props3.tailleMinimale;
      var tailles = this.tailles;

      if (!(0, _utilitaires.nestPasNulOuVide)(taille)) {
        return null;
      }

      if (!(0, _utilitaires.nestPasNulOuVide)(tailleMinimale) || [taille, tailleMinimale].some(function (t) {
        return tailles.indexOf(t) === -1;
      })) {
        return taille;
      }

      return tailles.indexOf(taille) < tailles.indexOf(tailleMinimale) ? tailleMinimale : taille;
    }
  }, {
    key: "obtenirControle",
    value: function obtenirControle() {
      var _this3 = this;

      var Controle = this.props.controle;

      if (!(0, _utilitaires.estDefini)(Controle)) {
        return null;
      }

      var _this$props4 = this.props,
          proprietesControle = _this$props4.proprietesControle,
          valeur = _this$props4.valeur,
          valeurInitiale = _this$props4.valeurInitiale,
          cliquable = _this$props4.cliquable;
      var props = this.obtenirPropsFiltrees();

      if ((0, _utilitaires.estDefini)(valeur)) {
        props.value = valeur;
      } else if ((0, _utilitaires.estDefini)(valeurInitiale)) {
        props.defaultValue = valeurInitiale;
      }

      if ((0, _utilitaires.estDefini)(proprietesControle)) {
        Object.assign(props, proprietesControle);
      }

      if ((0, _utilitaires.estDefini)(cliquable) && !!cliquable) {
        props.onClick = this.changement;
      } else {
        props.onChange = this.changement;
        props.onFocus = this.focus;
      }

      return /*#__PURE__*/_react.default.createElement(Controle, _extends({
        ref: function ref(_ref2) {
          return (0, _utilitaires.enregistrerSiDefini)(_this3, 'element', _ref2);
        },
        className: this.obtenirNomClasse(),
        name: this.props.nom,
        id: "".concat(this.idChamp, "-controle"),
        maxLength: (0, _utilitaires.estDefini)(this.props.longueurMaximale) ? this.props.longueurMaximale : undefined,
        onBlur: this.validation,
        placeholder: (0, _utilitaires.estDefini)(this.props.exemple) ? "ex. : ".concat(this.props.exemple) : undefined,
        readOnly: this.props.lectureSeule,
        disabled: (0, _utilitaires.estDefini)(this.props.desactive) ? this.props.desactive : false
      }, props));
    }
  }, {
    key: "obtenirMessageErreur",
    value: function obtenirMessageErreur() {
      var messageErreurProps = this.props.messageErreur;
      var messageErreurState = this.state.messageErreur;
      return (0, _utilitaires.estDefini)(messageErreurProps) ? messageErreurProps : messageErreurState;
    }
  }, {
    key: "changement",
    value: function changement(evennement) {
      var gererValeur = this.props.gererValeur;

      if ((0, _utilitaires.estDefini)(gererValeur)) {
        gererValeur(evennement.target, this.changementInterne.bind(this));
      } else {
        var value = evennement.target.value;
        this.changementInterne(value);
      }
    }
  }, {
    key: "changementInterne",
    value: function changementInterne(valeur) {
      var surChangement = this.props.surChangement;
      var messageErreur = this.state.messageErreur;

      if ((0, _utilitaires.estDefini)(surChangement)) {
        surChangement(valeur);
      }

      if ((0, _utilitaires.estDefini)(messageErreur)) {
        this.validationInterne(valeur);
      }
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, _MfaChampProprietes.MfaChampProprietes, this.props.proprietesFiltrees);
    }
  }, {
    key: "valeurCourante",
    value: function valeurCourante() {
      return (0, _utilitaires.estDefini)(this.props.valeur) ? this.props.valeur : null;
    }
  }, {
    key: "validation",
    value: function validation(evennement) {
      var value = evennement.target.value;
      this.validationInterne(value);
    }
  }, {
    key: "validationInterne",
    value: function () {
      var _validationInterne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valeur) {
        var _this4 = this;

        var _this$props5, surValidation, messageErreur, validationAsync, _messageErreur;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props5 = this.props, surValidation = _this$props5.surValidation, messageErreur = _this$props5.messageErreur, validationAsync = _this$props5.validationAsync;

                if (!(0, _utilitaires.estDefini)(messageErreur)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!(0, _utilitaires.estDefini)(surValidation)) {
                  _context.next = 12;
                  break;
                }

                _messageErreur = surValidation(valeur);

                if (!(validationAsync === true)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _messageErreur;

              case 8:
                _messageErreur = _context.sent;

              case 9:
                this.setState({
                  messageErreur: _messageErreur
                }, function () {
                  _this4.perteDeFocus(valeur);
                });
                _context.next = 13;
                break;

              case 12:
                this.perteDeFocus(valeur);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validationInterne(_x) {
        return _validationInterne.apply(this, arguments);
      }

      return validationInterne;
    }()
  }, {
    key: "perteDeFocus",
    value: function perteDeFocus(valeur) {
      var surPerteDeFocus = this.props.surPerteDeFocus;

      if (!(0, _utilitaires.estDefini)(surPerteDeFocus)) {
        return;
      }

      surPerteDeFocus(valeur);
    }
  }, {
    key: "focus",
    value: function focus(evenement) {
      var surFocus = this.props.surFocus;

      if ((0, _utilitaires.estDefini)(surFocus)) {
        var value = evenement.target.value;
        surFocus(value);
      }
    }
  }, {
    key: "obtenirNomClasse",
    value: function obtenirNomClasse() {
      var _this$props6 = this.props,
          className = _this$props6.className,
          classeControle = _this$props6.classeControle;

      if ((0, _utilitaires.nestPasNulOuVide)(className)) {
        return "".concat(classeControle, " ").concat(className);
      }

      return classeControle;
    }
  }]);

  return MfaChamp;
}(_react.Component);

exports.MfaChamp = MfaChamp;